export default {
  // 通用按钮
  "pages.common.ok": "确定",
  "pages.common.cancel": "取消",
  "pages.layouts.userLayout.title":
    "Ant Design 是西湖区最具影响力的 Web 设计规范",
  "pages.login.accountLogin.tab": "账户密码登录",
  "pages.login.accountLogin.errorMessage":
    "错误的用户名和密码(admin/ant.design)",
  "pages.login.failure": "登录失败，请重试！",
  "pages.login.success": "登录成功！",
  "pages.login.username.placeholder": "用户名: admin or user",
  "pages.login.username.required": "用户名是必填项！",
  "pages.login.password.placeholder": "密码: ant.design",
  "pages.login.password.required": "密码是必填项！",
  "pages.login.phoneLogin.tab": "手机号登录",
  "pages.login.phoneLogin.errorMessage": "验证码错误",
  "pages.login.phoneNumber.placeholder": "请输入手机号！",
  "pages.login.phoneNumber.required": "手机号是必填项！",
  "pages.login.phoneNumber.invalid": "不合法的手机号！",
  "pages.login.captcha.placeholder": "请输入验证码！",
  "pages.login.captcha.required": "验证码是必填项！",
  "pages.login.phoneLogin.getVerificationCode": "获取验证码",
  "pages.getCaptchaSecondText": "秒后重新获取",
  "pages.login.rememberMe": "自动登录",
  "pages.login.forgotPassword": "忘记密码 ?",
  "pages.login.submit": "登录",
  "pages.login.loginWith": "其他登录方式 :",
  "pages.login.registerAccount": "注册账户",
  "pages.login.logo.title": "No.1 Hoops",
  "pages.login.logo.subtitle": "管理系统",
  "pages.login.loginType.email": "邮箱登录",
  "pages.login.loginType.phone": "手机号登录",
  "pages.login.loginType.emailLabel": "邮箱",
  "pages.login.loginType.phoneLabel": "手机",
  "pages.login.email.placeholder": "请输入邮箱",
  "pages.login.email.required": "请输入邮箱",
  "pages.login.email.invalid": "请输入有效的邮箱地址",
  "pages.login.phone.placeholder": "请输入手机号",
  "pages.login.phone.required": "请输入手机号",
  "pages.login.phone.invalid": "请输入有效的手机号",
  "pages.login.password.placeholder": "请输入密码",
  "pages.login.errorMessage.email": "邮箱或密码错误",
  "pages.login.errorMessage.phone": "手机号或密码错误",
  "pages.login.pageTitle": "登录页 - No.1 Hoops 管理系统",
  "pages.welcome.link": "欢迎使用",
  "pages.welcome.alertMessage": "更快更强的重型组件，已经发布。",
  "pages.404.subTitle": "抱歉，您访问的页面不存在。",
  "pages.404.buttonText": "返回首页",
  "pages.admin.subPage.title": " 这个页面只有 admin 权限才能查看",
  "pages.admin.subPage.alertMessage":
    "umi ui 现已发布，欢迎使用 npm run ui 启动体验。",
  "pages.searchTable.createForm.newRule": "新建规则",
  "pages.searchTable.updateForm.ruleConfig": "规则配置",
  "pages.searchTable.updateForm.basicConfig": "基本信息",
  "pages.searchTable.updateForm.ruleName.nameLabel": "规则名称",
  "pages.searchTable.updateForm.ruleName.nameRules": "请输入规则名称！",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "规则描述",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder": "请输入至少五个字符",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "请输入至少五个字符的规则描述！",
  "pages.searchTable.updateForm.ruleProps.title": "配置规则属性",
  "pages.searchTable.updateForm.object": "监控对象",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "规则模板",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "规则类型",
  "pages.searchTable.updateForm.schedulingPeriod.title": "设定调度周期",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "开始时间",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules": "请选择开始时间！",
  "pages.searchTable.titleDesc": "描述",
  "pages.searchTable.ruleName": "规则名称为必填项",
  "pages.searchTable.titleCallNo": "服务调用次数",
  "pages.searchTable.titleStatus": "状态",
  "pages.searchTable.nameStatus.default": "关闭",
  "pages.searchTable.nameStatus.running": "运行中",
  "pages.searchTable.nameStatus.online": "已上线",
  "pages.searchTable.nameStatus.abnormal": "异常",
  "pages.searchTable.titleUpdatedAt": "上次调度时间",
  "pages.searchTable.exception": "请输入异常原因！",
  "pages.searchTable.titleOption": "操作",
  "pages.searchTable.config": "配置",
  "pages.searchTable.subscribeAlert": "订阅警报",
  "pages.searchTable.title": "查询表格",
  "pages.searchTable.new": "新建",
  "pages.searchTable.chosen": "已选择",
  "pages.searchTable.item": "项",
  "pages.searchTable.totalServiceCalls": "服务调用次数总计",
  "pages.searchTable.tenThousand": "万",
  "pages.searchTable.batchDeletion": "批量删除",
  "pages.searchTable.batchApproval": "批量审批",
  // 总览页面
  "pages.welcome.title": "总览",
  "pages.welcome.todayOpenCount": "今日开门次数",
  "pages.welcome.todayCloseCount": "今日关门次数",
  "pages.welcome.todayMemberCount": "今日来过会员数",
  "pages.welcome.openStatistics": "开门数据统计",
  "pages.welcome.period.week": "周",
  "pages.welcome.period.month": "月",
  "pages.welcome.chart.openCount": "开门次数",
  "pages.welcome.chart.times": "次",
  // 会员访问历史页面
  "pages.memberAccessHistory.title": "会员访问历史",
  "pages.memberAccessHistory.column.date": "日期",
  "pages.memberAccessHistory.column.memberId": "会员ID",
  "pages.memberAccessHistory.column.memberName": "会员姓名",
  "pages.memberAccessHistory.column.memberPhone": "手机号",
  "pages.memberAccessHistory.column.memberEmail": "邮箱",
  "pages.memberAccessHistory.column.anomalyCount": "异常次数",
  "pages.memberAccessHistory.column.action": "操作",
  "pages.memberAccessHistory.column.viewDetail": "查看详情",
  "pages.memberAccessHistory.column.selectDate": "请选择日期",
  "pages.memberAccessHistory.detail.title": "会员访问详情",
  "pages.memberAccessHistory.detail.column.time": "时间",
  "pages.memberAccessHistory.detail.column.action": "动作",
  "pages.memberAccessHistory.detail.column.status": "状态",
  "pages.memberAccessHistory.detail.column.operator": "操作人",
  "pages.memberAccessHistory.detail.column.countDeducted": "扣减次数",
  "pages.memberAccessHistory.detail.countDeducted.yes": "是",
  "pages.memberAccessHistory.detail.countDeducted.no": "否",
  "pages.memberAccessHistory.detail.action.open": "开门",
  "pages.memberAccessHistory.detail.action.close": "关门",
  "pages.memberAccessHistory.detail.status.success": "成功",
  "pages.memberAccessHistory.detail.status.failed": "失败",
  "pages.memberAccessHistory.detail.operator.user": "用户",
  "pages.memberAccessHistory.detail.operator.member": "会员",
  "pages.memberAccessHistory.detail.operator.unknown": "未知",
  // 会员管理页面
  "pages.members.title": "会员列表",
  "pages.members.column.id": "ID",
  "pages.members.column.name": "姓名",
  "pages.members.column.phone": "手机号",
  "pages.members.column.email": "邮箱",
  "pages.members.column.address": "地址",
  "pages.members.column.status": "状态",
  "pages.members.column.membershipType": "会员类型",
  "pages.members.column.remainingTime": "会员剩余可用",
  "pages.members.remainingTime.expired": "已过期",
  "pages.members.remainingTime.days": "天",
  "pages.members.remainingTime.hours": "小时",
  "pages.members.remainingTime.minutes": "分钟",
  "pages.members.remainingTime.countUnit": "次",
  "pages.members.column.createdAt": "创建时间",
  "pages.members.column.action": "操作",
  "pages.members.column.remark": "备注",
  "pages.members.column.tip.memberId": "会员ID",
  "pages.members.status.pending": "待审核",
  "pages.members.status.active": "激活",
  "pages.members.status.inactive": "禁用",
  "pages.members.action.activate": "激活",
  "pages.members.action.edit": "编辑",
  "pages.members.action.delete": "删除",
  "pages.members.action.delete.success": "删除成功",
  "pages.members.action.delete.failed": "删除失败，请重试",
  "pages.members.membershipType.time": "计时",
  "pages.members.membershipType.count": "计次",
  "pages.members.button.renewalBufferOnly": "即将过期",
  "pages.members.button.showAll": "显示全部",
  "pages.members.action.renew": "续费",
  "pages.members.action.rechargeRecords": "充值记录",
  "pages.members.action.confirm.activate": "确定要激活这个会员吗？",
  "pages.members.action.confirm.activateDesc": "激活后会员将可以使用系统功能",
  "pages.members.action.confirm.delete": "确定要删除这个会员吗？",
  "pages.members.action.confirm.ok": "确定",
  "pages.members.action.confirm.cancel": "取消",
  "pages.members.placeholder.selectStatus": "请选择状态",
  // 激活表单
  "pages.members.activateForm.title": "设置到期时间",
  "pages.members.activateForm.membershipType.label": "会员类型",
  "pages.members.activateForm.membershipType.required": "请选择会员类型",
  "pages.members.activateForm.expireDate.label": "到期时间",
  "pages.members.activateForm.expireDate.required": "请选择到期时间",
  "pages.members.activateForm.expireDate.placeholder": "请选择",
  "pages.members.activateForm.expireDate.extra": "选择到期日期，系统将设置为该日期的23:59:59",
  "pages.members.activateForm.renewalBufferHours.label": "续费缓冲期（小时）",
  "pages.members.activateForm.renewalBufferHours.extra": "会员到期后，在缓冲期内仍可使用（计时会员按小时记录）",
  "pages.members.activateForm.remainingCount.label": "剩余次数",
  "pages.members.activateForm.remainingCount.required": "请输入剩余次数",
  "pages.members.activateForm.remainingCount.min": "剩余次数必须大于0",
  "pages.members.activateForm.remainingCount.max": "剩余次数不能超过999999",
  "pages.members.activateForm.remainingCount.placeholder": "请输入剩余次数（1-999999）",
  "pages.members.activateForm.remark.label": "备注",
  "pages.members.activateForm.remark.placeholder": "请输入备注",
  "pages.members.activateForm.error.memberIdRequired": "会员ID不能为空",
  "pages.members.activateForm.error.memberIdInvalid": "会员ID格式不正确，请刷新页面后重试",
  "pages.members.activateForm.error.timeBasedExpireDateRequired": "计时类型必须设置到期时间",
  "pages.members.activateForm.error.countBasedRemainingCountRequired": "计次类型必须设置有效次数",
  "pages.members.activateForm.success": "激活成功",
  "pages.members.activateForm.error.failed": "激活失败，请重试",
  "pages.members.activateForm.error.refresh": "，请刷新页面后重试",
  // 充值记录
  "pages.members.rechargeRecords.title": "充值记录",
  "pages.members.rechargeRecords.close": "关闭",
  "pages.members.rechargeRecords.noRecords": "暂无充值记录",
  "pages.members.rechargeRecords.operationTime": "操作时间",
  "pages.members.rechargeRecords.type": "类型",
  "pages.members.rechargeRecords.status": "状态",
  "pages.members.rechargeRecords.status.valid": "有效",
  "pages.members.rechargeRecords.status.invalid": "无效",
  "pages.members.rechargeRecords.daysAdded": "增加天数",
  "pages.members.rechargeRecords.daysUnit": "天",
  "pages.members.rechargeRecords.countAdded": "增加次数",
  "pages.members.rechargeRecords.countUnit": "次",
  "pages.members.rechargeRecords.remark": "备注",
  "pages.members.rechargeRecords.revoke": "撤回",
  "pages.members.rechargeRecords.error.recordIdNotFound": "记录ID不存在",
  "pages.members.rechargeRecords.success.revoke": "撤回成功",
  "pages.members.rechargeRecords.error.revokeFailed": "撤回失败，请重试",
  "pages.members.rechargeRecords.error.fetchFailed": "获取充值记录失败，请重试",
  "pages.members.rechargeRecords.remark.memberActivation": "会员激活",
  // 续费表单
  "pages.members.renewForm.title": "续费",
  "pages.members.renewForm.currentRemainingTime": "当前会员剩余可用时间：",
  "pages.members.renewForm.expireTime": "到期时间：",
  "pages.members.renewForm.remainingCount": "剩余次数：",
  "pages.members.renewForm.countUnit": "次",
  "pages.members.renewForm.timeUnit.days": "天",
  "pages.members.renewForm.timeUnit.hours": "小时",
  "pages.members.renewForm.timeUnit.minutes": "分钟",
  "pages.members.renewForm.expired": "已过期",
  "pages.members.renewForm.newExpireDate.label": "新的到期日期",
  "pages.members.renewForm.newExpireDate.required": "请选择新的到期日期",
  "pages.members.renewForm.newExpireDate.placeholder": "请选择",
  "pages.members.renewForm.newExpireDate.extra": "选择新的到期日期，系统将设置为该日期的23:59:59",
  "pages.members.renewForm.newExpireDate.mustBeLater": "新的到期日期必须晚于当前到期日期",
  "pages.members.renewForm.renewalBufferHours.label": "续费缓冲期（小时）",
  "pages.members.renewForm.renewalBufferHours.extra": "会员到期后，在缓冲期内仍可使用（计时会员按小时记录，留空则保持原缓冲期不变）",
  "pages.members.renewForm.countToAdd.label": "续费增加次数",
  "pages.members.renewForm.countToAdd.required": "请输入增加的次数",
  "pages.members.renewForm.countToAdd.min": "增加次数必须大于0",
  "pages.members.renewForm.countToAdd.max": "增加次数不能超过999999",
  "pages.members.renewForm.countToAdd.placeholder": "请输入增加的次数（1-999999）",
  "pages.members.renewForm.remark.label": "备注",
  "pages.members.renewForm.remark.placeholder": "请输入备注",
  "pages.members.renewForm.error.memberIdRequired": "会员ID不能为空",
  "pages.members.renewForm.error.membershipTypeRequired": "会员类型不能为空，请刷新页面后重试",
  "pages.members.renewForm.success": "续费成功",
  "pages.members.renewForm.error.failed": "续费失败，请重试",
  // 新建会员表单
  "pages.members.createForm.title": "新建会员",
  "pages.members.createForm.name.label": "姓名",
  "pages.members.createForm.name.required": "请输入姓名",
  "pages.members.createForm.name.placeholder": "请输入姓名",
  "pages.members.createForm.phone.label": "手机号",
  "pages.members.createForm.phone.placeholder": "请输入手机号",
  "pages.members.createForm.email.label": "邮箱",
  "pages.members.createForm.email.invalid": "请输入有效的邮箱地址",
  "pages.members.createForm.email.placeholder": "请输入邮箱",
  "pages.members.createForm.password.label": "密码",
  "pages.members.createForm.password.required": "请输入密码",
  "pages.members.createForm.password.min": "密码至少6位",
  "pages.members.createForm.password.placeholder": "请输入密码（至少6位）",
  "pages.members.createForm.password.extra": "密码将用于会员登录验证",
  "pages.members.createForm.address.label": "地址",
  "pages.members.createForm.address.placeholder": "请输入地址",
  "pages.members.createForm.status.label": "状态",
  "pages.members.createForm.status.placeholder": "请选择状态",
  "pages.members.createForm.remark.label": "备注",
  "pages.members.createForm.remark.placeholder": "请输入备注",
  "pages.members.createForm.error.emailOrPhoneRequired": "请至少填写邮箱或手机号之一",
  "pages.members.createForm.contactType.label": "联系方式",
  "pages.members.createForm.contactType.required": "请选择联系方式类型",
  "pages.members.createForm.contactType.email": "邮箱",
  "pages.members.createForm.contactType.phone": "手机号",
  "pages.members.createForm.error.contactTypeRequired": "请选择联系方式类型（邮箱或手机号）",
  "pages.members.createForm.error.emailRequired": "请输入邮箱地址",
  "pages.members.createForm.error.phoneRequired": "请输入手机号",
  "pages.members.createForm.error.bothProvided": "邮箱和手机号只能选择其中一个",
  "pages.members.createForm.success": "创建成功",
  "pages.members.createForm.error.failed": "创建失败，请重试",
  // 编辑会员表单
  "pages.members.updateForm.title": "编辑会员",
  "pages.members.updateForm.name.label": "姓名",
  "pages.members.updateForm.name.required": "请输入姓名",
  "pages.members.updateForm.name.placeholder": "请输入姓名",
  "pages.members.updateForm.phone.label": "手机号",
  "pages.members.updateForm.phone.placeholder": "请输入手机号",
  "pages.members.updateForm.phone.extra": "不允许修改手机号",
  "pages.members.updateForm.email.label": "邮箱",
  "pages.members.updateForm.email.invalid": "请输入有效的邮箱地址",
  "pages.members.updateForm.email.placeholder": "请输入邮箱",
  "pages.members.updateForm.email.extra": "不允许修改邮箱",
  "pages.members.updateForm.password.label": "密码",
  "pages.members.updateForm.password.min": "密码至少6位",
  "pages.members.updateForm.password.placeholder": "留空则不修改密码",
  "pages.members.updateForm.password.extra": "留空则不修改密码",
  "pages.members.updateForm.address.label": "地址",
  "pages.members.updateForm.address.placeholder": "请输入地址",
  "pages.members.updateForm.status.label": "状态",
  "pages.members.updateForm.status.placeholder": "请选择状态",
  "pages.members.updateForm.membershipType.label": "会员类型",
  "pages.members.updateForm.membershipType.extra": "修改会员类型后，需要重新激活会员",
  "pages.members.updateForm.remark.label": "备注",
  "pages.members.updateForm.remark.placeholder": "请输入备注",
  "pages.members.updateForm.success": "更新成功",
  "pages.members.updateForm.error.failed": "更新失败，请重试",
  // 用户管理页面
  "pages.users.title": "用户列表",
  "pages.users.column.id": "ID",
  "pages.users.column.email": "邮箱",
  "pages.users.column.phone": "手机号",
  "pages.users.column.name": "姓名",
  "pages.users.column.role": "角色",
  "pages.users.column.status": "状态",
  "pages.users.column.createdAt": "创建时间",
  "pages.users.column.action": "操作",
  "pages.users.column.tip.userId": "用户ID",
  "pages.users.role.admin": "管理员",
  "pages.users.role.editor": "编辑",
  "pages.users.role.viewOnly": "查看",
  "pages.users.status.active": "激活",
  "pages.users.status.inactive": "禁用",
  "pages.users.action.edit": "编辑",
  "pages.users.action.delete": "删除",
  "pages.users.action.confirm.delete": "确定要删除这个用户吗？",
  // 新建用户表单
  "pages.users.createForm.title": "新建用户",
  "pages.users.createForm.email.label": "邮箱",
  "pages.users.createForm.email.invalid": "请输入有效的邮箱地址",
  "pages.users.createForm.email.placeholder": "请输入邮箱（邮箱和手机号至少填写一个）",
  "pages.users.createForm.phone.label": "手机号",
  "pages.users.createForm.phone.placeholder": "请输入手机号（邮箱和手机号至少填写一个）",
  "pages.users.createForm.password.label": "密码",
  "pages.users.createForm.password.required": "请输入密码",
  "pages.users.createForm.password.min": "密码至少6位",
  "pages.users.createForm.password.placeholder": "请输入密码（至少6位）",
  "pages.users.createForm.name.label": "姓名",
  "pages.users.createForm.name.placeholder": "请输入姓名",
  "pages.users.createForm.role.label": "角色",
  "pages.users.createForm.role.placeholder": "请选择角色",
  "pages.users.createForm.role.admin": "管理员（可增删查改）",
  "pages.users.createForm.role.editor": "编辑（可编辑）",
  "pages.users.createForm.role.viewOnly": "查看（仅可查看）",
  "pages.users.createForm.status.label": "状态",
  "pages.users.createForm.status.placeholder": "请选择状态",
  "pages.users.createForm.status.active": "激活",
  "pages.users.createForm.status.inactive": "禁用",
  "pages.users.createForm.error.emailOrPhoneRequired": "请至少填写邮箱或手机号之一",
  "pages.users.createForm.success": "创建成功",
  "pages.users.createForm.error.failed": "创建失败，请重试",
  // 编辑用户表单
  "pages.users.updateForm.title": "编辑用户",
  "pages.users.updateForm.email.label": "邮箱",
  "pages.users.updateForm.email.invalid": "请输入有效的邮箱地址",
  "pages.users.updateForm.email.placeholder": "请输入邮箱",
  "pages.users.updateForm.email.extra": "不允许修改邮箱",
  "pages.users.updateForm.phone.label": "手机号",
  "pages.users.updateForm.phone.placeholder": "请输入手机号",
  "pages.users.updateForm.phone.extra": "不允许修改手机号",
  "pages.users.updateForm.password.label": "密码",
  "pages.users.updateForm.password.min": "密码至少6位",
  "pages.users.updateForm.password.placeholder": "留空则不修改密码",
  "pages.users.updateForm.password.extra": "留空则不修改密码",
  "pages.users.updateForm.name.label": "姓名",
  "pages.users.updateForm.name.placeholder": "请输入姓名",
  "pages.users.updateForm.role.label": "角色",
  "pages.users.updateForm.role.placeholder": "请选择角色",
  "pages.users.updateForm.role.admin": "管理员（可增删查改）",
  "pages.users.updateForm.role.editor": "编辑（可编辑）",
  "pages.users.updateForm.role.viewOnly": "查看（仅可查看）",
  "pages.users.updateForm.role.extra": "编辑角色无权修改用户角色",
  "pages.users.updateForm.status.label": "状态",
  "pages.users.updateForm.status.placeholder": "请选择状态",
  "pages.users.updateForm.status.active": "激活",
  "pages.users.updateForm.status.inactive": "禁用",
  "pages.users.updateForm.success": "更新成功",
  "pages.users.updateForm.error.failed": "更新失败，请重试",
};
